import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"
import { LoaderIcon } from "components"
import Summary from "components/summary"
import { A, StarIcon, Interactive } from "AtomicComponents"
import { Disclaimer } from "AtomicContainers"

const RenderPrice = ({ price, disclaimer, gtm }) => (
  <div style={{ whiteSpace: "noWrap" }}>
    <A
      withoutStyle
      style={{ fontSize: "32px" }}
      onClick={(event) => {
        if (event && event.target && event.target.querySelector('button')) {
          event.target.querySelector('button').click()
        }
      }}
    >
      ${!!price && price.toLocaleString()}
      <Disclaimer
        Icon={StarIcon}
        gtm={{
          category: gtm.category,
          action: gtm.action
        }}>
        {disclaimer}
      </Disclaimer>
    </A>
  </div>
)

const renderPriceStyles = {
  sup: {
    lineHeight: 0.5,
    fontSize: "50%"
  }
}

RenderPrice.propTypes = {
  disclaimer: PropTypes.string,
  gtmEvents: PropTypes.array,
  price: PropTypes.number
}

const mapItems = ({
  label, value, priceDifference, ...rest
}, index) => ({
  label,
  value: [
    <span key={index + "value"} style={styles.value}>{value}</span>,
    !!priceDifference && (
      <span key={index + "value"} style={styles.value}>
      ${Number(priceDifference).toLocaleString('nz')}
      </span>
    )
  ],
  ...rest
})

const SummaryWithPrice = ({
  previousGeneration,
  items = [],
  gtm,
  price,
  safetyModel,
  includeSafetyModel = false,
  ...rest
}) => (
  <Summary items={items.map(mapItems)} {...rest}>
    {
      safetyModel &&
      <div style={{
        textAlign: "left",
        borderTop: "1px solid #dddddd",
        marginTop: "1.5em",
        paddingTop: "1.5em"
      }}>
      <Interactive>Options</Interactive>
      {safetyModel}
      </div>
    }
    <div data-test="price" style={styles.priceContainer}>
      <Interactive>{price.message || "Recommended Retail Price"}</Interactive>
      <span style={styles.price}>
        {!!price.price && (
          <RenderPrice price={includeSafetyModel && price.safetyModelPrice ? price.safetyModelPrice : price.price} disclaimer={price.disclaimer} gtm={gtm} />
        )}
        {!price.price && (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <LoaderIcon />
          </div>
        )}
      </span>
    </div>
  </Summary>
)

SummaryWithPrice.propTypes = {
  heading: PropTypes.string,
  previousGeneration: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.node
  })),
  gtmEvents: PropTypes.array,
  disableBase: PropTypes.bool,
  price: PropTypes.shape({
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    price: PropTypes.number,
    disclaimer: PropTypes.string
  })
}

export default Radium(SummaryWithPrice)

const styles = {
  label: {
    color: "#aaa",
    textTransform: "uppercase",
    fontSize: "80%",
    margin: ".5em 0",
    display: "block",
    fontWeight: 600,
    letterSpacing: ".2em",
    textAlign: "left",
    flex: "1 1 40%"
  },
  priceContainer: {
    borderTop: "1px solid #ddd",
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    padding: '1.5em 0px',
    margin: '24px 0px 0px 0px'
  },
  price: {
    flex: "1 1 50%",
    fontSize: "200%",
    fontWeight: 200,
    textAlign: "right"
  }
}



// WEBPACK FOOTER //
// ./src/components/summary-with-price/index.jsx